import { render, staticRenderFns } from "./EuropeanSingle.vue?vue&type=template&id=5fbe5e32&scoped=true"
import script from "./EuropeanSingle.vue?vue&type=script&lang=js"
export * from "./EuropeanSingle.vue?vue&type=script&lang=js"
import style0 from "./EuropeanSingle.vue?vue&type=style&index=0&id=5fbe5e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbe5e32",
  null
  
)

export default component.exports